// ------------------------------------
// Lateral fixa
// ------------------------------------
(function () {
  'use strict';
  if ($('.pag-prod-right').length > 0 && !$('body').hasClass('pdl2') && (isMedia('lg') || isMedia('xl'))) {
    const winHeight = $(window).height();
    let lastScrollTop = 0;
    let curScrollTop = 0;
    let scrollDir = 'bottom';
    let sideTop = 0;
    let headerHeight = 0;
    let menuHeight = 0;
    if ($('.header.fixed').length > 0) {
      headerHeight = $('.header.fixed').outerHeight();
    }
    if ($('.menu-full.fixed').length > 0) {
      menuHeight = $('.menu-full.fixed').outerHeight();
    }
    const viewHeight = winHeight - (headerHeight + menuHeight);

    $(window).on(
      'scroll',
      debounce(function () {
        const sideHeight = $('.pag-prod-right').outerHeight();

        // Verifica a direção do scroll
        curScrollTop = $(this).scrollTop();
        if (curScrollTop > lastScrollTop) {
          scrollDir = 'bottom';
        } else {
          scrollDir = 'top';
        }
        lastScrollTop = curScrollTop;

        // Ajusta a posição da lateral
        if (sideHeight > viewHeight) {
          if (scrollDir === 'top') {
            sideTop = headerHeight + menuHeight + 20;
            $('.pag-prod-right').css('top', sideTop);
          } else if (scrollDir === 'bottom') {
            sideTop = sideHeight - $(window).height() + 20;
            sideTop = -Math.abs(sideTop);
            $('.pag-prod-right').css('top', sideTop);
          }
        } else {
          sideTop = headerHeight + 20;
          if (scrollDir === 'top') {
            sideTop = headerHeight + menuHeight + 20;
          }
          $('.pag-prod-right').css('top', sideTop);
        }
      }, 25),
    );
  }
})();

// ------------------------------------
// Fotos (Carrossel)
// ------------------------------------
(function () {
  'use strict';

  const produtoFotosCarrosel = '#carrosel-produto';
  const $produtoFotosCarrosel = $(produtoFotosCarrosel);
  const produtoThumbsCarrosel = '#carrosel-produto-thumbs';
  const $produtoThumbsCarrosel = $(produtoThumbsCarrosel);
  const produtoFotosQtde = $('.carrosel-produto-foto').length;

  // Configurações carrossel principal
  let produtoFotosCarroselOpt = {
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    swipe: false,
    infinite: true,
    autoplay: false,
    // Responsivo
    responsive: [
      // Tablet
      {
        breakpoint: 960,
        settings: {
          fade: false,
          swipe: true,
        },
      },
      // Mobile
      {
        breakpoint: 480,
        settings: {
          fade: false,
          swipe: true,
          arrows: false,
        },
      },
    ],
  };

  // Configurações carrossel thumbs
  let produtoThumbsCarroselOpt = {
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    arrows: false,
    focusOnSelect: true,
    infinite: false,
    asNavFor: produtoFotosCarrosel,
    // Responsivo
    responsive: [
      // Tablet
      {
        breakpoint: 960,
        settings: 'unslick',
        /* settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false,
        }, */
      },
      // Mobile
      {
        breakpoint: 480,
        settings: 'unslick',
        /* settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false,
        }, */
      },
    ],
  };

  /* if ((isMedia('sm') || isMedia('xs')) && produtoFotosQtde > 4) {
    produtoFotosCarroselOpt.asNavFor = produtoThumbsCarrosel;
    produtoThumbsCarroselOpt.infinite = true;
  } */

  if (isMedia('md') || isMedia('sm') || isMedia('xs')) {
    $('#carrosel-produto-thumbs .carousel-item[data-thumb-image]').on('click', function (ev) {
      ev.preventDefault();
      const imageID = $(this).data('thumb-image');
      const $imageSlide = $('#carrosel-produto .carousel-item[data-image="' + imageID + '"]');
      if ($imageSlide.length > 0) {
        const imageIndex = $imageSlide.data('slick-index');
        if ($('#carrosel-produto').hasClass('slick-initialized')) {
          $('#carrosel-produto').slick('slickGoTo', imageIndex);
        }
      }
    });
  }

  // Carrosel Principal
  $produtoFotosCarrosel.slick(produtoFotosCarroselOpt);

  // Carrosel Thumbs
  if (isMedia('xl') || isMedia('lg')) {
    $produtoThumbsCarrosel.slick(produtoThumbsCarroselOpt);
  }

  // Ao clicar na thumb do vídeo é ancorado para a seção do vídeo
  $('.video-anchor').on('click', function (ev) {
    ev.preventDefault();
    smoothScroll('#video-sec');
  });
})();

// ------------------------------------
// Zoom
// ------------------------------------
function initProdDetZoom() {
  if ($('.produto-fotos').hasClass('enable-zoom') && (isMedia('xl') || isMedia('lg'))) {
    $('.produto-fotos').addClass('zoom-loaded');
    $('.carrosel-produto-foto').each(function () {
      const $el = $(this);
      const imgLg = $(this).data('img-lg');
      $el.zoom({
        url: imgLg,
        magnify: 0.75,
      });
    });
  }
}
function destroyProdDetZoom() {
  if ($('.produto-fotos').length > 0) {
    $('.carrosel-produto-foto').each(function () {
      const $el = $(this);
      $el.trigger('zoom.destroy');
    });
  }
}
if ($('.produto-fotos').length > 0) {
  $('.produto-fotos').on('mouseenter', function () {
    if (!$('.produto-fotos').hasClass('zoom-loaded')) {
      initProdDetZoom();
    }
  });
  $(window).on(
    'hresize ',
    debounce(function () {
      destroyProdDetZoom();
      initProdDetZoom();
    }, 100),
  );
}

// ------------------------------------
// Lightbox
// ------------------------------------
function initLightbox($wrapper, extraOpts = {}) {
  if (!$wrapper || $wrapper.length === 0) {
    return false;
  }
  const $images = $wrapper.find('[data-lightbox]');
  if ($images.length > 0) {
    const lightboxCfg = {
      navText: ['', ''],
      closeText: '',
      captionPosition: 'outside',
      fileExt: false,
      heightRatio: 0.8,
      captionSelector: 'self',
      captionType: 'data',
      animationSpeed: 150,
      history: false,
      ...extraOpts,
    };
    const lightbox = $images.simpleLightbox(lightboxCfg);
    return lightbox;
  }
  return false;
}
(function () {
  'use strict';
  // Lightbox fotos de detalhe
  const prodFotosLightBox = initLightbox($('.produto-fotos'));
  if (prodFotosLightBox) {
    $('.produto-fotos-zoom-alert').on('click', function () {
      prodFotosLightBox.open();
    });
  }
})();

// ------------------------------------
// Pessoas comprando no momento
// ------------------------------------
let pBuyCurTimer;
function initpBuyCur() {
  let interval = 15; // Intervalo em segundos
  interval = interval * 1000;
  if (pBuyCurTimer !== undefined) {
    clearInterval(pBuyCurTimer);
  }
  const $el = $('.produto-comprando .md-text');
  if ($el.length > 0) {
    let htmlText = $el.html();
    htmlText = htmlText.replace(/{.*}/g, '<span>' + getRandomNumber() + '</span>');
    $el.html(htmlText);
    pBuyCurTimer = setInterval(() => {
      $el.html($el.html().replace(/<span>.*<\/span>/g, '<span>' + getRandomNumber() + '</span>'));
    }, interval);
    function getRandomNumber() {
      return randomNumber(6, 12);
    }
  }
}
initpBuyCur();

// ------------------------------------
// Quantidade em estoque (Gatilho)
// ------------------------------------
function initStockView() {
  const $el = $('.produto-estoque');
  if ($el.length > 0) {
    const estoqueTipo = $el.data('estoque-tipo');
    const estoqueReal = $el.data('estoque-real');
    const estoqueFicticio = $el.data('estoque-ficticio');
    const estoqueView = estoqueTipo == 'real' ? estoqueReal : estoqueFicticio;
    let htmlText = $el.find('.md-text').html();
    htmlText = htmlText.replace(/{.*}/g, '<span>' + estoqueView + '</span>');
    htmlText = htmlText.replace(/<span>.*<\/span>/g, '<span>' + estoqueView + '</span>');
    $el.find('.md-text').html(htmlText);
    if (estoqueTipo === 'real' && estoqueReal == 0) {
      $el.hide();
    }
  }
}
initStockView();

// ------------------------------------
// Variantes e atributos
// ------------------------------------
(function () {
  'use strict';
  const $variants = $('[data-variants]');
  if ($('.pag-produto').length > 0) {
    // Variáveis
    const variants = $variants.data('variants');
    const $priceOld = $('.prod-preco-old, .popup-buy-price-old');
    const $price = $('.prod-preco-new');
    const $quantity = $('.produto-det-quantidade #quantity');
    const $btnBuy = $('#btn-buy');
    const $alertStock = $('.produto-det-indisponivel');
    const $variant = $('#variant');
    const $installmentsInfos = $('.prod-preco-parc');
    let installmentsInfos = $installmentsInfos.data('installments');
    let gateway = installmentsInfos?.gateway;
    let maxInstallments = installmentsInfos?.max_installments || 1;
    let maxInstallmentsFree = installmentsInfos?.max_installments_free || 1;
    let installmentsFreeShow = installmentsInfos?.installments_free_show == '1';
    let installmentsArr = installmentsInfos?.installments || [];
    let variant;

    // Altera a variante ao alterar algum atributo
    $('.produto-det-atributo .attr-radio, .produto-det-atributo .attr-select').on('click', function () {
      window.change_p_slide = true;
    });
    $('.produto-det-atributo .attr-radio, .produto-det-atributo .attr-select').on('change', function () {
      getAttrVariant();
      $('body').trigger('variant-change');
    });
    $('body').on('recalc-parc', function () {
      getAttrVariant();
    });

    // Retorna o slug da variante com base nos atributos selecionados
    function getAttrVariant() {
      let variantSlug = [];
      $('.produto-det-atributo .attr-radio:checked, .produto-det-atributo .attr-select').each(function () {
        const $input = $(this);
        const attrName = $input.attr('name');
        const attrValue = slugify($input.val());
        const $optValue = $('[data-opt-value="' + attrName + '"]');
        let optTitle;
        if ($input.hasClass('attr-radio')) {
          optTitle = $input.data('title');
        } else if ($input.hasClass('attr-select')) {
          optTitle = $input.find('option:selected').data('title');
        }
        if (optTitle) {
          $optValue.text(optTitle);
        } else {
          $optValue.text('');
        }
        variantSlug.push(attrName + ':' + attrValue);
      });
      variantSlug = variantSlug.join('|');
      showVariantInfos(variantSlug ? variantSlug : 'u');
    }

    // Exibe as informações de parcelamento
    function showInstallmentsInfos(listaParcelas) {
      if (maxInstallments > 0 && listaParcelas.length > 0) {
        let lastParcela = listaParcelas.slice(-1)[0];
        if (installmentsFreeShow) {
          lastParcela = listaParcelas.filter((item) => item.sem_juros).slice(-1)[0];
        }
        populaParcelas(listaParcelas);
        if (lastParcela) {
          const semJuros = lastParcela.sem_juros ? ' sem juros' : '';
          const initTxt = lastParcela.sem_juros ? 'Em até' : 'Ou em';
          const parcTxt = `${initTxt} <b>${lastParcela.num_parcela}x</b> de <b>R$ ${formatMoneyBR(
            lastParcela.valor_parcela,
          )}</b>${semJuros}`;
          $installmentsInfos.html(parcTxt);
          $('.popup-buy-price-parc').html(parcTxt);
          $installmentsInfos.css('opacity', 1);
        }
      }
    }

    // Exibe as informações da variante selecionada
    function showVariantInfos(variantSlug) {
      variant = getVariant(variantSlug);
      if (variant !== undefined) {
        //console.log(variant);
        console.log('Variante: ' + variant.sku);
        window.curVariant = variant;
        window.curVariant.product_title = $('.prod-title').text();

        // Seta a variante no botão
        $btnBuy.data('variant', variant.sku);

        // SKU
        $variant.val(variant.sku);
        if ($('.prod-sku').length) {
          $('.prod-sku').text('SKU: ' + variant.sku);
        }

        // Foca a imagem
        if (variant.image_id != '' && window.change_p_slide) {
          focusSlideImage(variant.image_id);
        }

        // Preço antigo
        $priceOld.hide();
        if (Number(variant.old_price) > 0) {
          $priceOld.html('R$ ' + formatMoneyBR(Number(variant.old_price)));
          $priceOld.show();
        }

        // Preço atual
        $btnBuy.data('product-val', variant.sale_price);
        $price.html('R$ ' + formatMoneyBR(Number(variant.sale_price)));
        $('.v-price').text('R$ ' + formatMoneyBR(Number(variant.sale_price)));

        // Calcula e exibe as informações de parcelamento
        $installmentsInfos.css('opacity', 0);
        if (maxInstallments > 0) {
          let listaParcelas = [];
          // Mercado Pago
          /* if (gateway === 'mercadopago') {
            getMercadoPagoInstallments(Number(variant.sale_price), maxInstallments, showInstallmentsInfos);
          } */
          // Pagseguro
          if (gateway === 'pagseguro') {
            getPagSeguroInstallments(
              Number(variant.sale_price),
              maxInstallments,
              maxInstallmentsFree,
              showInstallmentsInfos,
            );
          }
          // Parcelamento interno
          else {
            getInterntInstallments(
              gateway,
              Number(variant.sale_price),
              maxInstallments,
              maxInstallmentsFree,
              showInstallmentsInfos,
            );
          }
        }

        // Descontos
        $('.prod-preco-discount').hide();
        $('.prod-preco-economia').hide();
        if (Number(variant.old_price) > 0) {
          let discountPercent = 100 - (Number(variant.sale_price) * 100) / Number(variant.old_price);
          discountPercent = parseInt(discountPercent);
          let discountPriceDiff = Number(variant.old_price) - Number(variant.sale_price);
          if (discountPercent > 0) {
            if ($('.prod-preco-discount').length > 0) {
              $('.prod-preco-discount').text(discountPercent + '% Off');
              $('.prod-preco-discount').show();
            }
            if ($('.prod-preco-economia').length > 0) {
              $('.prod-preco-economia').text('Economia de R$ ' + formatMoneyBR(discountPriceDiff));
              $('.prod-preco-economia').show();
            }
          }
        }

        // Descontos
        $('[data-discount]').each(function () {
          const $discount = $(this);
          const $discountPrice = $discount.find('.discount-price');
          const $discountPercent = $discount.find('.discount-percent');
          const $econPrice = $discount.find('.discount-econ');
          const discountPercent = $discount.data('discount') ? Number($discount.data('discount')) : 0;
          const discountPrice = (discountPercent * Number(variant.sale_price)) / 100;
          const newPrice = Number(variant.sale_price) - discountPrice;
          let discountPercentTxt = formataDesconto(discountPercent) + '% Off';
          let discountPercentTxt2 = formataDesconto(discountPercent) + '% de desconto';
          $discountPrice.text('R$ ' + formatMoneyBR(newPrice));
          $discountPercent.text(discountPercentTxt);
          if ($discount.hasClass('pd-disc-pix')) {
            $discountPercent.text(discountPercentTxt2);
          }
          const method = $discount.data('discount-method');
          const $viewPrice = $('.v-price-' + method);
          if ($viewPrice.length > 0) {
            $viewPrice.text('R$ ' + formatMoneyBR(newPrice));
          }
          let econPrice = Number(variant.sale_price) - newPrice;
          $econPrice.text('R$ ' + formatMoneyBR(econPrice));
          $discount.show();
        });

        // Desconto pix (Superdestaque)
        if ($('.pd-disc-pix').length) {
          $('.prod-pay-desc[data-discount-method="pix"]').hide();
        }

        // Quantidade
        const cartMaxQty = $('#infos-base').data('cart-maxqty');
        if (variant.automatic_stock == '1') {
          if (variant.quantity > 0) {
            let maxQty = variant.quantity > cartMaxQty ? cartMaxQty : variant.quantity;
            $quantity.attr('max', maxQty);
          } else {
            $quantity.attr('max', 1);
          }
        } else {
          $quantity.attr('max', cartMaxQty);
          //$quantity.removeAttr('max');
        }
        $quantity.val(1);
        initSpinners();
        $('.produto-estoque').data('estoque-real', variant.quantity);
        initStockView();

        // Botão compra
        if (variant.automatic_stock == '1' && variant.quantity == 0) {
          $alertStock.show();
          $btnBuy.prop('disabled', true);
        } else {
          $alertStock.hide();
          $btnBuy.prop('disabled', false);
        }

        // Cálculo de frete
        if ($('.pag-prod-right .cart-ship-wrp').length) {
          $('#cart-zipcode').trigger('get-shipping');
        }

        $('body.pag-produto').trigger('prod-var-change');
      }
    }

    // Retorna uma variante com base no slug
    function getVariant(variantSlug) {
      return variants.filter((item) => item.slug == variantSlug)[0];
    }

    // Foca a imagem da variante no carrossel de fotos
    function focusSlideImage(imageID) {
      const $imageSlide = $('#carrosel-produto .carousel-item[data-image="' + imageID + '"]');
      if ($imageSlide.length > 0) {
        const imageIndex = $imageSlide.data('slick-index');
        if ($('#carrosel-produto').hasClass('slick-initialized')) {
          $('#carrosel-produto').slick('slickGoTo', imageIndex);
        }
      }
      const $imageThumb = $('#carrosel-produto-thumbs .carousel-item[data-thumb-image="' + imageID + '"]');
      if ($imageThumb.length > 0) {
        if (isMedia('xs') || isMedia('sm')) {
          let offsetLeft = $imageThumb.offset().left;
          if (offsetLeft < 0) {
            offsetLeft = 0;
          } else {
            offsetLeft = offsetLeft - 20;
          }
          $('.carrosel-produto-thumbs').scrollLeft(offsetLeft);
        } else {
          const imageIndex = $imageThumb.data('slick-index');
          if ($('#carrosel-produto-thumbs').hasClass('slick-initialized')) {
            $('#carrosel-produto-thumbs').slick('slickGoTo', imageIndex);
          }
        }
      }
    }

    // Pré-seleciona a primeira variante disponível
    preSelectVariant();
    function preSelectVariant() {
      let variant = variants.filter((item) => {
        return item.automatic_stock == '0' || (item.automatic_stock == '1' && item.quantity > 0);
      })[0];
      if (variant !== undefined) {
        if (variant.slug === 'u') {
          showVariantInfos('u');
        } else {
          const variantArr = variant.slug.split('|');
          variantArr.forEach((item) => {
            const optArr = item.split(':');
            const optName = optArr[0];
            const optValue = optArr[1];
            let $select = $(`.produto-det-atributo .attr-select[name="${optName}"]`);
            let $radio = $(`.produto-det-atributo .attr-radio[name="${optName}"][value="${optValue}"]`);
            if ($select.length > 0) {
              $select.val(optValue).trigger('change');
            } else if ($radio.length > 0) {
              $radio.prop('checked', true).trigger('change');
            }
          });
        }
      } else {
        variant = variants[0];
        if (variant) {
          showVariantInfos(variant.slug);
        }
      }
    }

    // Popula a lista dos parcelamentos no modal
    function populaParcelas(parcelas) {
      const $listaParcelas = $('#modal-det-pagamento .installments-list');
      $listaParcelas.html('');
      parcelas.forEach((parcela) => {
        let semJurosSufix = '';
        if (parcela.sem_juros) {
          semJurosSufix = parcela.num_parcela > 1 ? ' sem juros' : ' à vista';
        }
        $listaParcelas.append(`
        <li class="installments-list-item">
          <span class="installments-list-item-left"><b>${parcela.num_parcela}x</b> de <b>R$ ${formatMoneyBR(
          parcela.valor_parcela,
        )}</b>${semJurosSufix}</span>
          <span class="installments-list-item-right">Total: <b>R$ ${formatMoneyBR(parcela.valor_total)}</b></span>
        </li>`);
      });
    }
  }
})();

// Destaque desconto progressivo
(function () {
  'use strict';
  initDestProgressiveDisc();
  $('body.pag-produto').on('prod-var-change', initDestProgressiveDisc);
  // Carrega a informação
  function initDestProgressiveDisc() {
    if ($('.produto-det-pgr-disc-wrp').length) {
      let prodPrice =
        curVariant.sale_price || Number(formatMoneyBD($('.prod-preco-new').first().text().replace('R$ ', '')));
      const discInfos = $('.produto-det-pgr-disc-wrp').data('info');
      $('.produto-det-pgr-list').html();
      if (discInfos.length) {
        $('.produto-det-pgr-list').html('');
        discInfos.forEach((item) => {
          const percentView = item.percent.replace('.', ',');
          const total = Number(item.quantity) * prodPrice;
          const disc = (total * Number(item.percent)) / 100;
          const totalDisc = total - disc;
          $('.produto-det-pgr-list').append(`<li class="produto-det-pgr-i">
            <div class="produto-det-pgr-i-col produto-det-pgr-i-qty" data-val="${item.quantity}">Leve ${
            item.quantity
          } unidades</div>
            <div class="produto-det-pgr-i-col produto-det-pgr-i-percent nowrap" data-val="${percentView}">${percentView}% Off</div>
            <div class="produto-det-pgr-i-col produto-det-pgr-i-total nowrap" data-val="${formatMoneyBR(
              totalDisc,
            )}">R$ ${formatMoneyBR(totalDisc)}</div>
            <div class="produto-det-pgr-i-col produto-det-pgr-i-btn"><button class="btn btn-xs btn-buy" data-qty="${
              item.quantity
            }" title="Comprar esta quantidade"><span class="icon">+</span><span class="txt">Comprar</span></button></div>
          </li>`);
        });
        $('.produto-det-pgr-disc-wrp').removeClass('d-none');
        $('.produto-det-pgr-disc-wrp').trigger('pd-loaded');
      }
    }
  }
  // Evento de clique no botão rápido
  $('body').on('click', '.produto-det-pgr-i-btn .btn-buy', function (ev) {
    ev.preventDefault();
    const quantity = $(this).data('qty');
    $('#quantity').val(quantity).trigger('change');
    $('#btn-buy').trigger('click');
  });
})();

// ------------------------------------
// Adiciona no carrinho
// ------------------------------------

// Ao clicar no botão para adicionar no carrinho
$('#btn-buy').on('click', function (ev) {
  ev.preventDefault();
  if (!previewMode) {
    const variant = $(this).data('variant');
    const quantity = $('#quantity').val() || 1;
    if (validateCustomizations()) {
      addToCart($('#btn-buy'), variant, quantity);
    }
  }
});

// Exibe a mensagem de sucesso no carrinho lateral
function showCartSideAlert() {
  const $el = $('.cart-side-alert');
  $el.addClass('active');
  setTimeout(() => {
    $el.removeClass('active');
  }, 2000);
}

// Adiciona o produto ao carrinho
function addToCart($btnBuy, variant, quantity = 1) {
  const urlCart = urlBase + 'core/acoes/checkout/cart.php';
  let isKit = false;
  let type;
  let kitID = 0;
  let productId = 0;
  let productURL = '';
  let kitOptSKU = '';
  let productPrice = 0;
  let productsList = [];
  let productQuantity = 1;
  let modalCartShow = false;
  let skipCart = false;
  let cartSideEnable = $('#cart-side ').length > 0;
  let cartIncrement = $('#infos-base').data('cart-increment');

  if (!variant) {
    const alertMsg = LPQV.message_required_variant || 'Por favor, selecione uma opção para este produto.';
    showAlert('Atenção', alertMsg, 'warning');
    return false;
  }

  // Verifica se o produto já está no carrinho
  if (!cartIncrement && alreadyInCart(variant)) {
    if (cartSideEnable) {
      sideToggle('cart-side');
    } else {
      location.href = urlBase + cartInfos.cart_url;
    }
    return false;
  }

  // Verifica se o modal será exibido ou será redirecionado
  if ($btnBuy.data('show-modal-cart')) {
    modalCartShow = true;
  }

  // Verifica se a opção de pular carrinho está habilitada
  if ($btnBuy.data('skip-cart')) {
    skipCart = true;
  }

  // Produto padrão
  if (!isKit) {
    type = 'default';
    productId = $btnBuy.data('product-id');
    productURL = $btnBuy.data('product-url');
    productPrice = Number($btnBuy.data('product-val'));
    productPrice = productPrice ? productPrice : 0;
    productsList.push({
      product_id: productId,
      product_url: productURL,
      variant: variant,
      quantity: quantity,
    });
  }
  const data = {
    store_token: publicToken,
    lp_url: urlBaseLp,
    type: type,
    kit_id: kitID,
    kit_opt_sku: kitOptSKU,
    products: productsList,
    lp_id: baseLanding,
    product_id: productId,
    quantity: productQuantity,
  };

  // Customizações
  if ($btnBuy.data('customizations')) {
    data.customizations = JSON.parse($btnBuy.data('customizations'));
  }

  // Dispara pixels de addtocart
  function dispatchAddToCartEvents() {
    dispatchPixelEvent('facebook', 'AddToCart', {
      content_type: 'product_group',
      content_ids: [productsList[0]['variant']],
      value: productsList[0]['quantity'] * productPrice,
      currency: 'BRL',
    });
    dispatchAddToCartAnalytics();
    dispatchAddToCartPinterest();
    dispatchAddToCartTiktok();
    dispatchAddToCartKwai();
    dispatchAddToCartOutbrain();
  }

  showLoader();
  $.getJSON(urlCart, data, function (result) {
    console.log(result);
    if (result.status === 'success') {
      let cartUrl = result.checkout_url.split('/');
      const cartToken = cartUrl[cartUrl.length - 1];

      // Exibe o carrinho lateral
      if (cartSideEnable) {
        dispatchAddToCartEvents();
        hideLoader();
        if (cartToken) {
          getCart(() => {
            if ($('.cart-btn-cta').length) {
              $('.cart-btn-cta').attr('href', result.checkout_url);
            }
            showCartSideAlert();
            sideOpen('cart-side');
          });
        }
        return false;
      }

      // Exibe modal de alerta
      if (modalCartShow) {
        if (cartToken) {
          getCart();
        }
        // Pular carrinho
        if (skipCart) {
          $('#modal-cart .modal-cart-btns .btn').first().attr('href', result.checkout_url);
        }
        hideLoader();
        modalOpen('modal-cart');
        dispatchAddToCartEvents();
        return false;
      }

      // Sem modal de alerta
      else {
        // Pular carrinho
        if (skipCart) {
          hideLoader();
          location.href = result.checkout_url;
        } else {
          dispatchAddToCartEvents();
          setTimeout(() => {
            hideLoader();
            location.href = urlBase + 'cart';
          }, 2000);
        }
      }
    } else {
      hideLoader();
      showAlert('Erro', 'Não foi possível realizar esta operação.', 'danger');
    }
  }).fail(function (qXHR, textStatus, errorThrown) {
    console.log(qXHR);
    hideLoader();
    showAlert('Erro', 'Não foi possível realizar esta operação.', 'danger');
  });
}

// Verifica as customizações preenchidas
function validateCustomizations() {
  let customObj = [];
  const $btnBuy = $('#btn-buy');
  if ($('.produto-det-custom').length > 0) {
    let numInvalid = 0;
    const parsleyOptObj = {
      errorClass: 'is-invalid',
      successClass: 'is-valid',
      classHandler: function (el) {
        return el.$element.closest('.form-group');
      },
      errorsContainer: function (el) {
        return el.$element.closest('.form-group');
      },
    };
    $(
      '.produto-det-custom-item .form-input, .produto-det-custom-item .attr-radio, .produto-det-custom-item .ns-input',
    ).each(function () {
      const $input = $(this);
      if (!$input.hasClass('ignore')) {
        $input.parsley(parsleyOptObj).validate();
        if (!$input.parsley().isValid()) {
          numInvalid++;
        } else if ($input.val() != '') {
          let price_add = 0;
          if ($input.hasClass('attr-radio')) {
            if ($input.is(':checked')) {
              price_add = $input.data('c-price') || 0;
            }
          } else if ($input.prop('tagName') === 'SELECT' || $input.prop('tagName') === 'select') {
            if ($input.data('c-price')) {
              price_add = $input.data('c-price');
            } else {
              price_add = $input.find('option:selected').data('c-price') || 0;
            }
          } else {
            price_add = $input.data('c-price');
          }
          if ($input.hasClass('attr-radio')) {
            if ($input.is(':checked')) {
              customObj.push({
                customization_id: $input.data('c-id'),
                title: $input.data('c-title'),
                value: $input.val(),
                price_add: Number(price_add),
              });
            }
          } else {
            customObj.push({
              customization_id: $input.data('c-id'),
              title: $input.data('c-title'),
              value: $input.val(),
              price_add: Number(price_add),
            });
          }
        }
      }
    });
    if (numInvalid > 0) {
      return false;
    }
    if (customObj.length > 0) {
      customObj = JSON.stringify(customObj);
      $btnBuy.data('customizations', customObj);
    }
  }
  return true;
}
$('.produto-det-custom-item .form-input, .produto-det-custom-item .attr-radio, .produto-det-custom-item .ns-input').on(
  'change',
  function () {
    const $input = $(this);
    $('body').trigger('prod-custom-change', { item: $input });
  },
);

// Desabilita a pré-seleção de variante
function disablePreSelectVars() {
  $('.produto-det-atributo .attr-select').each(function () {
    $(this).val('').trigger('change');
  });
  $('.produto-det-atributo .attr-radio').each(function () {
    $(this).prop('checked', false).trigger('change');
  });
  $('.produto-det-atributo .form-label [data-opt-value]').html('');
  curVariant = null;
  $('#btn-buy').data('variant', '');
}

// Verifica se o produto já foi adicionado ao carrinho
function alreadyInCart(varSKU) {
  const cartItems = cartInfos?.result?.items;
  if (typeof cartInfos === 'object' && cartItems && cartItems.length > 0) {
    return cartItems.some((cartI) => cartI.variant_sku === varSKU);
  }
  return false;
}

// ------------------------------------
// Mercado Pago
// ------------------------------------

// Inicia o Mercado Pago
/* $('body').on('mp-loaded', function () {
  if (typeof Mercadopago != 'undefined') {
    getMercadoPagoToken(function () {
      $('body').trigger('recalc-parc');
      if ($('.prod-preco-parc').length > 0) {
        $('.prod-preco-parc').trigger('recalc');
      }
    });
  }
}); */

// Obtém o token
/* function getMercadoPagoToken(callback = false) {
  if ($('#gateway-infos').length && $('#gateway-infos').data('token')) {
    const gatewayToken = $('#gateway-infos').data('token');
    Mercadopago.setPublishableKey(gatewayToken);
    if (typeof callback === 'function') {
      callback();
    }
  } else {
    console.log('Não foi possível obter o token do Mercado Pago.');
  }
} */

// Obtém as parcelas do cartão
/* function getMercadoPagoInstallments(amount, parcelas, callback = false) {
  parcelas = !parcelas ? 1 : parcelas;
  const cardBin = 503143;
  if (typeof Mercadopago != 'undefined') {
    Mercadopago.getInstallments(
      {
        bin: cardBin,
        amount: parseFloat(amount),
      },
      function (status, response) {
        if (status == 200) {
          console.log(response);
          let installments = response[0]?.payer_costs || [];
          // Formata as parcelas para o formato utilizado
          let newInstallments = [];
          let countParc = 0;
          installments.forEach((item) => {
            if (countParc < parcelas) {
              countParc++;
              newInstallments.push({
                num_parcela: item.installments,
                valor_total: item.total_amount,
                sem_juros: item.installment_rate === 0,
                valor_parcela: item.installment_amount,
              });
            }
          });
          //console.log(newInstallments);
          if (callback !== false) {
            callback(newInstallments);
          } else {
            console.log(newInstallments);
          }
        } else {
          console.log('Não foi possível obter as parcelas do Mercado Pago.');
        }
      },
    );
  }
} */

// ------------------------------------
// PagSeguro
// ------------------------------------

// Inicia o PagSeguro
$('body').on('ps-loaded', function () {
  if (typeof PagSeguroDirectPayment != 'undefined') {
    getPagSeguroToken(function () {
      $('body').trigger('recalc-parc');
      if ($('.prod-preco-parc').length > 0) {
        $('.prod-preco-parc').trigger('recalc');
      }
    });
  }
});

// Obtém o token
function getPagSeguroToken(callback = false) {
  const urlSession = urlBase + 'core/acoes/checkout/pagseguro_get_session.php';
  $.getJSON(`${urlSession}?store_token=${publicToken}`, function (result) {
    //console.log(result);
    PagSeguroDirectPayment.setSessionId(result.session_id);
    if (typeof callback === 'function') {
      callback();
    }
  }).fail(function (result) {
    console.log('Não foi possível obter o token do PagSeguro.', result);
  });
}

// Obtém as parcelas do cartão
function getPagSeguroInstallments(amount, parcelas, maxInstallmentsFree, callback = false) {
  parcelas = !parcelas ? 1 : parcelas;
  if (typeof PagSeguroDirectPayment != 'undefined') {
    const cardBrand = 'mastercard';
    const total = amount;
    const opts = {
      amount: total,
      brand: cardBrand,
      success: function (response) {
        let installments = response.installments[cardBrand];
        // Formata as parcelas para o formato utilizado
        let newInstallments = [];
        let countParc = 0;
        installments.forEach((item) => {
          if (countParc < parcelas) {
            countParc++;
            newInstallments.push({
              num_parcela: item.quantity,
              valor_total: item.totalAmount,
              sem_juros: item.interestFree,
              valor_parcela: item.installmentAmount,
            });
          }
        });
        if (callback !== false) {
          callback(newInstallments);
        }
      },
      error: function (response) {
        console.log(response);
      },
    };
    // Parcelas sem juros
    if (maxInstallmentsFree && maxInstallmentsFree > 1) {
      opts.maxInstallmentNoInterest = maxInstallmentsFree;
    }
    PagSeguroDirectPayment.getInstallments(opts);
  }
}

// ------------------------------------
// Parcelamento interno
// ------------------------------------
function getInterntInstallments(gateway, amount, maxInstallments, maxInstallmentsFree, callback = false) {
  const urlApi = urlBase + 'core/acoes/checkout/parcelamentos.php';
  const cardNumber = 5031433215406351;
  // Realiza a requisição dos dados
  $.getJSON(
    `${urlApi}?origem=page&gateway=${gateway}&amount=${amount}&cardNumber=${cardNumber}&maxInstallments=${maxInstallments}&maxInstallmentsFree=${maxInstallmentsFree}&store_token=${publicToken}&storeId=${baseLanding}&lp_type=store`,
    function (result) {
      console.log(result);
      let newInstallments = [];
      let countParc = 0;
      if (result.installments) {
        let installments = result.installments;
        // Formata as parcelas para o formato utilizado
        installments.forEach((item) => {
          if (countParc < maxInstallments) {
            countParc++;
            const diffParc = Number(item.amount) - amount;
            //const semJuros = diffParc < 0.1; // Tolerância de 1 centavo
            let semJuros = false;
            if (Number(item.installment) <= Number(maxInstallmentsFree)) {
              semJuros = true;
            }
            newInstallments.push({
              num_parcela: Number(item.installment),
              valor_total: Number(item.amount),
              //sem_juros: Number(item.amount) <= amount,
              sem_juros: semJuros,
              valor_parcela: Number(item.installment_amount),
            });
          }
        });
      } else {
        console.log('Não foi possível obter o parcelamento.');
      }
      if (callback !== false) {
        callback(newInstallments);
      }
    },
  ).fail(function (result) {
    console.log(result);
  });
}

// Popup Mobile
(function () {
  'use strict';

  // Variáveis
  const $popupBuy = $('.popup-buy');
  const $popupBuyBtn = $popupBuy.find('.popup-buy-btn .btn');

  // Click no botão de compra
  $popupBuyBtn.on('click', function (ev) {
    const variant = $('#variant').val();
    smoothScroll('.prod-precos');
    if (variant != '') {
      $('#btn-buy').trigger('click');
    }
  });

  // Exibe ou oculta o popup com base no scroll
  if ($('#btn-buy').length > 0 && (isMedia('md') || isMedia('sm') || isMedia('xs'))) {
    function isBtnOutViewport() {
      const $elem = $('#btn-buy');
      const elementTop = $elem.offset().top;
      const elementBottom = elementTop + $elem.outerHeight();
      const viewportTop = $(window).scrollTop();
      return elementBottom < viewportTop;
    }
    function handleViewPopupBuy() {
      if (isBtnOutViewport('#btn-buy') && isElementOutViewport('#footer')) {
        $popupBuy.addClass('active');
      } else {
        $popupBuy.removeClass('active');
      }
    }
    $(window).on('scroll resize', debounce(handleViewPopupBuy, 50));
  }
})();

// Avaliações
(function () {
  'use strict';

  // Variáveis
  const $btnLoad = $('.btn-reviews-load');
  const $reviewsList = $('.prod-av-list');
  const reviewsLayout = $reviewsList.hasClass('mansory') ? 'mansory' : 'list';
  let paginaAtual = 0;
  let macyInstance;
  let firstCallScroll = false;
  let reviewsLightbox = false;

  // Ao clicar para carregar as avaliações
  $btnLoad.on('click', function (ev) {
    ev.preventDefault();
    getReviews();
  });

  // Carrega as avaliações ao carregar a página e dar scroll
  if ($reviewsList.length > 0) {
    doWhenVisible($('#avaliacoes-sec'), function () {
      if (!firstCallScroll) {
        getReviews();
      }
    });
  }

  // Obtém as avaliações
  function getReviews() {
    firstCallScroll = true;
    paginaAtual++;
    const urlApi = urlBase + 'core/acoes/themes/boosterstore/produtos/get_reviews.php';
    const data = {
      store_token: publicToken,
      prod: LPQV.product_id,
      pag: paginaAtual,
    };
    $btnLoad.prop('disabled', true).addClass('btn-loader').text('Aguarde');
    $.getJSON(urlApi, data, function (result) {
      console.log(result);
      resetBtnLoad();
      if (result.num_rows > 0) {
        if (paginaAtual == result.pag_total) {
          disableLoad();
        }
        populateReviews(result.result);
      } else {
        disableLoad();
      }
    }).fail(function (qXHR, textStatus, errorThrown) {
      resetBtnLoad();
      console.log(qXHR);
    });
  }

  function resetBtnLoad() {
    $btnLoad.prop('disabled', false).removeClass('btn-loader').text('+ Ver mais avaliações');
  }

  function disableLoad() {
    $btnLoad.parent().hide();
  }

  // Popula reviews
  async function populateReviews(reviews) {
    $reviewsList.removeClass('empty');
    reviews.forEach((review) => {
      review.comment = fixEmojiReview(review.comment);
      // Layout lista
      if (reviewsLayout === 'list') {
        let $rStars = '';
        for (let i = 1; i <= 5; i++) {
          const starActive = review.stars >= i ? 'active' : '';
          $rStars += `<label class="${starActive}"><svg class="i-star" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"/></svg></label>`;
        }
        let $rDate = '';
        if (LPQV.reviews_date_show && review.date_view) {
          //$rDate = `<div class="prod-av-item-date">${formataDataExt(review.created_at, '{M} {Y}')}</div>`;
          $rDate = `<div class="prod-av-item-date">${review.date_view}</div>`;
        }
        let $images = '';
        if (review.images_view && review.images_view.length > 0) {
          $images += '<div class="prod-av-item-images">';
          review.images_view.forEach((img) => {
            $images += `
            <a class="img img-border img-rounded" href="${img.image}" data-lightbox rel="av-${review.id}" data-title="${review.name}: ${review.comment}"><img src="${img['thumb-150']}" width="100px" height="100px" alt="Avaliação: ${review.name} - Foto"></a>`;
          });
          $images += '</div>';
        }
        const $review = `
        <li class="prod-av-item">
          <div class="prod-av-item-stars">
            <div class="star-rating">${$rStars}</div>
          </div>
          <div class="prod-av-item-title-wrp">
            <div class="prod-av-item-title">${review.name}</div>
            ${$rDate}
          </div>
          <div class="prod-av-item-text">${review.comment}</div>
          ${$images}
        </li>`;
        $reviewsList.append($review);
      }
      // Layout mosaico
      else if (reviewsLayout === 'mansory') {
        let $rStars = '';
        for (let i = 1; i <= 5; i++) {
          const starActive = review.stars >= i ? 'active' : '';
          $rStars += `<label class="${starActive}"><svg class="i-star" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"/></svg></label>`;
        }
        let $rDate = '';
        if (LPQV.reviews_date_show && review.date_view) {
          //$rDate = `<div class="prod-av-item-date">${formataDataExt(review.created_at, '{M} {Y}')}</div>`;
          $rDate = `<div class="prod-av-item-date">${review.date_view}</div>`;
        }
        let $images = '';
        let noImgClass = 'no-img';
        if (review.images_view && review.images_view.length > 0) {
          noImgClass = '';
          const img = review.images_view[0];
          $images += `<div class="prod-av-item-images"><a class="img" href="${img.image}" data-lightbox rel="av-${review.id}" data-title="${review.name}: ${review.comment}"><img src="${img['thumb-250']}" width="205px" height="205px" alt="Avaliação: ${review.name} - Foto"></a></div>`;
        }
        const $review = `
        <li class="prod-av-item">
          ${$images}
          <div class="prod-av-item-stars ${noImgClass}">
            <div class="star-rating">${$rStars}</div>
          </div>
          <div class="prod-av-item-title-wrp">
            <div class="prod-av-item-title">${review.name}</div>
            ${$rDate}
          </div>
          <div class="prod-av-item-text">${review.comment}</div>
        </li>`;
        $reviewsList.append($review);
      }
    });
    if (reviewsLayout === 'mansory') {
      if (!macyInstance) {
        initMansory();
      } else {
        macyInstance.recalculate(true);
      }
    }
    // Inicia o Lightbox
    if (reviewsLightbox) {
      reviewsLightbox.destroy();
    }
    reviewsLightbox = initLightbox($reviewsList, {
      className: 'prod-av-lightbox',
    });
  }

  // Inicia plugin mosaico
  function initMansory() {
    macyInstance = Macy({
      container: '.mansory',
      trueOrder: false,
      waitForImages: false,
      columns: 3,
      margin: {
        x: 15,
        y: 15,
      },
      breakAt: {
        480: 2,
      },
    });
    macyInstance.on(macyInstance.constants.EVENT_IMAGE_COMPLETE, function (ctx) {
      $('.mansory').removeClass('pre-mansory');
    });
    setTimeout(() => {
      macyInstance.recalculate(true);
    }, 1000);
  }

  // Correção provisória para os emojis
  function fixEmojiReview(reviewText) {
    const emojis = ['😀', '😃', '😄', '😁', '😍', '👏', '❤️'];
    const emoji = emojis[Math.floor(Math.random() * emojis.length)];
    return reviewText.replace(/\?\?\?\?/g, emoji);
  }
})();

// ------------------------------------
// Carrinho AJAX
// ------------------------------------
(function () {
  'use strict';

  // Variáveis
  const $side = $('#prod-det-side');
  const $btnProd = $('.prod-bl-wrp.cart-ajax .btn-prod-buy, .prod-bl-wrp.cart-ajax .cart-ajax-btn');
  const $btnBuy = $side.find('.btn-buy');
  const $quantity = $('#prod-side-quantity');
  let $btnLoad;
  let btnText;
  let prodUrl;
  let prodId;
  let prod;
  let variants;

  // Evento de clique
  if ($btnProd.length) {
    $btnProd.on('click', function (ev) {
      ev.preventDefault();
      $btnLoad = $(this);
      btnText = $btnLoad.html();
      const $prod = $btnLoad.closest('.prod-bl-wrp');
      if ($prod.length) {
        prodUrl = $prod.attr('href');
        prodId = $prod.data('product');
        getProduct();
      }
    });
  }

  // Restaura o botão de compra
  function resetBtnLoad() {
    $btnLoad.prop('disabled', false).removeClass('btn-loader').html(btnText);
  }

  // Obtém os detalhes do produto
  function getProduct() {
    const urlApi = urlBase + 'core/acoes/themes/boosterstore/produtos/get_product.php';
    const data = {
      store_token: publicToken,
      lp: baseLanding,
      prod: prodId,
    };
    $btnLoad.prop('disabled', true).addClass('btn-loader').html('');
    $.getJSON(urlApi, data, function (result) {
      resetBtnLoad();
      if (result.status === 'success') {
        prod = result.product;
        populateProdSide();
      } else {
        console.log(result);
        if (!getUrlParam('debug_js')) {
          window.location.href = prodUrl;
        }
      }
    }).fail(function (qXHR, textStatus, errorThrown) {
      console.log(qXHR);
      resetBtnLoad();
      if (!getUrlParam('debug_js')) {
        window.location.href = prodUrl;
      }
    });
  }

  // Popula o produto na lateral
  function populateProdSide() {
    const thumb = getThumb(prod.image, 100, 100, 'crop');
    $side.find('.prod-side-img img').attr('src', thumb);
    $side.find('.prod-side-tit').text(prod.title);
    $side.find('.prod-side-price .new').text('R$ ' + formatMoneyBR(prod.sale_price));
    if (prod.old_price > 0) {
      $side
        .find('.prod-side-price .old')
        .text('R$ ' + formatMoneyBR(prod.old_price))
        .show();
    } else {
      $side.find('.prod-side-price .old').hide();
    }
    $side.find('.btn-2').attr('href', prodUrl);

    // Atributos
    prod = getProdAttrs(prod);
    const $attrWrp = $side.find('.produto-det-atributos');
    const $attrList = $side.find('.produto-det-atributos > .row');
    $attrList.html('');
    prod.variants_items.forEach(function (attr) {
      if (attr['input_type'] == 'select') {
        let $opts = '';
        attr['variant_values'].forEach(function (attrOpt) {
          $opts += `<option value="${attrOpt['slug']}" data-title="${attrOpt['title']}" ${attrOpt['disabled']}>${attrOpt['title']}</option>`;
        });
        const $attr = `<div class="grid-8 grid-md-4 grid-xs-12 produto-det-atributo">
          <div class="form-group">
            <label for="attr-${attr['slug']}" class="form-label">${attr['title']}: <span data-opt-value="${attr['slug']}"></span></label>
            <div class="form-input-group">
              <select name="${attr['slug']}" id="attr-${attr['slug']}" class="form-input attr-select" data-parsley-required-message="Selecione uma opção" required>
                <option value="" hidden>Selecione</option>
                ${$opts}
              </select>
              <div class="select-arrow"></div>
            </div>
          </div>
        </div>`;
        $attrList.append($attr);
      } else if (attr['input_type'] == 'radio') {
        let $opts = '';
        attr['variant_values'].forEach(function (attrOpt) {
          $opts += `<div class="form-check-card">
            <input type="radio" name="${attr['slug']}" id="attr-${attr['slug']}-${attrOpt['slug']}" class="attr-radio" value="${attrOpt['slug']}" data-parsley-required-message="Selecione uma opção" ${attrOpt['disabled']} data-title="${attrOpt['title']}" required>
            <label for="attr-${attr['slug']}-${attrOpt['slug']}">${attrOpt['title']}</label>
          </div>`;
        });
        const $attr = `<div class="grid-12 produto-det-atributo">
          <div class="form-group form-group-check-card">
            <label class="form-label">${attr['title']}: <span data-opt-value="${attr['slug']}"></span></label>
            ${$opts}
          </div>
        </div>`;
        $attrList.append($attr);
      } else if (attr['input_type'] == 'image') {
        let $opts = '';
        attr['variant_values'].forEach(function (attrOpt) {
          $opts += `<div class="form-check-img">
            <input type="radio" name="${attr['slug']}" id="attr-${attr['slug']}-${attrOpt['slug']}" class="attr-radio" value="${attrOpt['slug']}" data-parsley-required-message="Selecione uma opção" ${attrOpt['disabled']} data-title="${attrOpt['title']}" required>
            <label for="attr-${attr['slug']}-${attrOpt['slug']}" title="${attrOpt['title']}"><img src="${attrOpt['image']}" alt="${attrOpt['title']}"></label>
          </div>`;
        });
        const $attr = `<div class="grid-12 produto-det-atributo">
          <div class="form-group form-group-check-img">
            <label class="form-label">${attr['title']}: <span data-opt-value="${attr['slug']}"></span></label>
            ${$opts}
          </div>
        </div>`;
        $attrList.append($attr);
      }
    });

    variants = prod?.variants;
    $quantity.val(1);
    // Caso tenha apenas uma variante, já adiciona no carrinho
    /* if (variants.length === 1 && variants[0].slug === 'u') {
      window.curVariant = variants[0];
      window.curVariant.product_title = prod.title;
      $btnBuy.data('product-id', prodId);
      $btnBuy.data('product-url', prodUrl);
      $btnBuy.data('product-val', variants[0].sale_price);
      $btnBuy.data('variant', variants[0].sku);
      addToCartSide();
    }
    // Exibe a lateral para selecionar a variante
    else {
      preSelectVariant();
      sideOpen('prod-det-side');
    } */
    preSelectVariant();
    sideOpen('prod-det-side');
  }

  // Monta os atributos
  function getProdAttrs(prod) {
    if (typeof prod.variants_items === 'object' && prod.variants_items.length > 0) {
      prod.variants_items.forEach(function (attrV, attrK) {
        prod.variants_items[attrK]['slug'] = slugify(attrV.title);
        const variantValues = attrV['variant_values'].split(',');
        const variantValues2 = [];
        variantValues.forEach(function (attrOptV, attrOptK) {
          const variantSlugOpt = slugify(attrV['title']) + ':' + slugify(attrOptV);
          const attrOptArr = {
            title: attrOptV,
            slug: slugify(attrOptV),
            disabled: 'disabled',
          };

          if (attrV['input_type'] == 'image') {
            prod.variants.forEach(function (variantItem) {
              const variantItemArr = variantItem['slug'].split('|');
              if (!attrOptArr['image']) {
                if (variantItemArr.indexOf(variantSlugOpt) !== -1) {
                  attrOptArr['image'] = getProdImage(prod['images'], variantItem['image_id']);
                }
              }
            });
          }
          prod.variants.forEach(function (variantItem) {
            const variantItemArr = variantItem['slug'].split('|');
            if (variantItemArr.indexOf(variantSlugOpt) !== -1) {
              if (
                variantItem['automatic_stock'] != '1' ||
                (variantItem['automatic_stock'] == '1' && variantItem['quantity'] > 0)
              ) {
                attrOptArr['disabled'] = '';
              }
            }
          });
          variantValues2.push(attrOptArr);
        });
        prod['variants_items'][attrK]['variant_values'] = variantValues2;
      });
    }
    return prod;
  }

  // Retorna a imagem do produto
  function getProdImage(imagesList, imgId) {
    const thumb = imagesList.filter((imageItem) => imageItem['id'] == imgId);
    if (thumb[0]?.thumb_sm) {
      return thumb[0]?.thumb_sm;
    }
    return false;
  }

  // Retorna o slug da variante com base nos atributos selecionados
  $side.on('change', '.attr-radio, .attr-select', function () {
    getAttrVariant();
  });
  function getAttrVariant() {
    let variantSlug = [];
    $(
      '#prod-det-side .produto-det-atributo .attr-radio:checked, #prod-det-side .produto-det-atributo .attr-select',
    ).each(function () {
      const $input = $(this);
      const attrName = $input.attr('name');
      const attrValue = slugify($input.val());
      const $optValue = $('[data-opt-value="' + attrName + '"]');
      let optTitle;
      if ($input.hasClass('attr-radio')) {
        optTitle = $input.data('title');
      } else if ($input.hasClass('attr-select')) {
        optTitle = $input.find('option:selected').data('title');
      }
      if (optTitle) {
        $optValue.text(optTitle);
      } else {
        $optValue.text('');
      }
      variantSlug.push(attrName + ':' + attrValue);
    });
    variantSlug = variantSlug.join('|');
    showVariantInfos(variantSlug ? variantSlug : 'u');
  }

  // Pré-seleciona a primeira variante disponível
  function preSelectVariant() {
    let variant = variants.filter((item) => {
      return item.automatic_stock == '0' || (item.automatic_stock == '1' && item.quantity > 0);
    })[0];
    if (variant !== undefined) {
      if (variant.slug === 'u') {
        showVariantInfos('u');
      } else {
        const variantArr = variant.slug.split('|');
        variantArr.forEach((item) => {
          const optArr = item.split(':');
          const optName = optArr[0];
          const optValue = optArr[1];
          let $select = $(`#prod-det-side .produto-det-atributo .attr-select[name="${optName}"]`);
          let $radio = $(`#prod-det-side .produto-det-atributo .attr-radio[name="${optName}"][value="${optValue}"]`);
          if ($select.length > 0) {
            $select.val(optValue).trigger('change');
          } else if ($radio.length > 0) {
            $radio.prop('checked', true).trigger('change');
          }
        });
      }
    } else {
      variant = variants[0];
      if (variant) {
        showVariantInfos(variant.slug);
      }
    }
  }

  // Exibe as informações da variante selecionada
  function showVariantInfos(variantSlug) {
    let variant = getVariant(variantSlug);
    if (variant !== undefined) {
      console.log('Variante: ' + variant.sku);
      window.curVariant = variant;
      window.curVariant.product_title = prod.title;
      $btnBuy.data('product-id', prodId);
      $btnBuy.data('product-url', prodUrl);
      $btnBuy.data('product-val', variant.sale_price);
      $btnBuy.data('variant', variant.sku);

      // Imagem
      let imageVar = getProdImage(prod.images, variant.image_id);
      if (!imageVar) {
        imageVar = prod.image;
      }
      const thumb = getThumb(imageVar, 100, 100, 'crop');
      $side.find('.prod-side-img img').attr('src', thumb);

      // Preço
      $side.find('.prod-side-price .new').text('R$ ' + formatMoneyBR(Number(variant.sale_price)));
      if (variant.old_price > 0) {
        $side
          .find('.prod-side-price .old')
          .text('R$ ' + formatMoneyBR(variant.old_price))
          .show();
      } else {
        $side.find('.prod-side-price .old').hide();
      }

      // Quantidade
      const cartMaxQty = $('#infos-base').data('cart-maxqty');
      if (variant.automatic_stock == '1') {
        if (variant.quantity > 0) {
          let maxQty = variant.quantity > cartMaxQty ? cartMaxQty : variant.quantity;
          $quantity.attr('max', maxQty);
        } else {
          $quantity.attr('max', 1);
        }
      } else {
        $quantity.attr('max', cartMaxQty);
        //$quantity.removeAttr('max');
      }
      //$quantity.val(1);
      initSpinners();

      // Botão compra
      if (variant.automatic_stock == '1' && variant.quantity == 0) {
        $btnBuy.prop('disabled', true);
      } else {
        $btnBuy.prop('disabled', false);
      }
    }
  }

  // Retorna uma variante com base no slug
  function getVariant(variantSlug) {
    return variants.filter((item) => item.slug == variantSlug)[0];
  }

  // Ao clicar no botão para adicionar no carrinho
  $btnBuy.on('click', function (ev) {
    ev.preventDefault();
    addToCartSide();
  });
  function addToCartSide() {
    if (!previewMode) {
      const variant = $btnBuy.data('variant');
      if (variant) {
        const quantity = $quantity.val() || 1;
        addToCart($btnBuy, variant, quantity);
        sideClose('prod-det-side');
      } else {
        showAlert('Atenção', 'Selecione uma opção do produto.', 'warning');
      }
    }
  }
})();

// ------------------------------------
// Stock Alerts
// ------------------------------------
(function () {
  'use strict';
  $('.btn-stock-alert').on('click', function (ev) {
    ev.preventDefault();
    $('#modal-stock-alert input[name="variant_sku"]').val(window?.curVariant?.sku);
    modalOpen('modal-stock-alert');
  });
})();
